import { Helmet } from "react-helmet-async";

const SITE_URL = "https://lutherclub.de";

interface PageSeoProps {
  title: string;
  description: string;
  path: string;
  jsonLd?: object | object[];
  ogType?: string;
  noindex?: boolean;
}

const PageSeo = ({ title, description, path, jsonLd, ogType = "website", noindex = false }: PageSeoProps) => {
  const url = `${SITE_URL}${path}`;
  const schemas = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={ogType} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {schemas.map((s, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(s)}
        </script>
      ))}
    </Helmet>
  );
};

export default PageSeo;
